/** Logos for organizations on the home page (`/public/logos/`). */
export const affiliationLogos = [
  { name: 'SCU Formula SAE Racing', logo: '/logos/formula-sae-logo.png' },
  { name: 'ColorStack', logo: '/logos/colorstack-logo.png' },
  { name: 'HeadStart Fellowship', logo: '/logos/headstart-logo.png' },
  { name: "MLT Career Prep '28", logo: '/logos/mlt-logo.png' },
  { name: 'LEAD First-Gen Scholars Program', logo: '/logos/lead-logo.jpg' },
  { name: 'SHPE', logo: '/logos/shpe-logo.png' }
];
